import { EventManyQuery } from "gql/generated";
import { useEffect, useState } from "react";
import { DateRange, EventWidgetSize } from "widgets/events/types";

type UseFeaturedEventsProps = {
  dateRange: DateRange;
  events: EventManyQuery["eventMany"][0][];
  widgetSize: EventWidgetSize;
};

export const useFeaturedEvents = ({
  dateRange,
  events,
  widgetSize,
}: UseFeaturedEventsProps) => {
  // We need to take the future event notice into account when calculating the total number of events
  const totalEvents = events.length + (dateRange.showFutureEventNotice ? 1 : 0);
  const [eventsPerPage, setEventsPerPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  useEffect(() => {
    const prevEventsPerPage = eventsPerPage;
    const newEventsPerPage =
      widgetSize === EventWidgetSize.Mobile
        ? totalEvents
        : widgetSize === EventWidgetSize.Tablet
          ? 3
          : widgetSize === EventWidgetSize.Desktop
            ? 6
            : 9;
    setEventsPerPage(newEventsPerPage);
    setTotalPages(Math.ceil(totalEvents / newEventsPerPage));
    setCurrentPage((prev) =>
      prev > 1
        ? Math.floor((prevEventsPerPage * prev) / newEventsPerPage)
        : totalEvents > 0
          ? 1
          : 0,
    );
  }, [eventsPerPage, totalEvents, widgetSize]);

  /**
   * When the events change, we can override the above calculation and
   * always go back to page 1
   * This is important when applying filters and switching months
   */
  useEffect(() => {
    setCurrentPage(events.length > 0 ? 1 : 0);
  }, [events]);

  const handlePageChange = (dir: number) =>
    setCurrentPage((prev) => prev + dir);

  return {
    currentPage,
    eventsPerPage,
    totalPages,
    handlePageChange,
  };
};
